enum EScoreGroupName {
  Interesting = 'Interesting',
  Sherlock4 = 'Sherlock4',
}

export default EScoreGroupName;
